export enum SpecType {
  LIST = 'list',
  CLINICAL_NOTES = 'clinicalNotes',
  SINGLE_CHOICE = 'singleChoice',
  BOOLEAN_CHOICE = 'booleanChoice',
}

export enum InputType {
  ITEMS = 'items',
  RANGE = 'range',
}
